import _ from "lodash";
import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { SharedProperties } from "./share.service";
import { NotificationsService } from "./notification.service";
import { IApiTorns, ITorns } from "./api.model";

export class TornsService {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/torn/`;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $http: ng.IHttpService,
  ) {
    this.apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/torn/`;
  }

  init(): ng.IPromise<ITorns> {
    return this.$http.get<IApiTorns>(`${this.apiurl}findAllFPiADP`, {})
      .then((data) => {
        let torns = data.data.torns;

        torns = torns.map((o) => ({
          ...o, name: o.label, id: o.codi,
        }));

        torns = _.sortBy(_.filter(torns, (o) => o.codi !== 'NA'), 'name');

        return {
          CFA: _.cloneDeep(torns),
          CFP: _.cloneDeep(torns),
          PFI: _.cloneDeep(torns),
        };
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return null;
      });
  }
}

angularJsApp.service(AppServicesEnum.TORNS_SERVICE, TornsService);